var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9,19.8A9.9,9.9,0,1,0,0,9.9,9.929,9.929,0,0,0,9.9,19.8Z",
    transform: "translate(1.1 1.1)",
    fill: "#fef2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,.75A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H8.671a.75.75,0,0,1,.75.75.75.75,0,0,1-.75.75Z",
    transform: "translate(7.934 14.065) rotate(-45)",
    fill: "#f37070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.421a.749.749,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V8.671A.75.75,0,0,1,0,9.421Z",
    transform: "translate(7.934 7.934) rotate(-45)",
    fill: "#f37070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H22V22H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Icon);
export default __webpack_public_path__ + "static/media/01_icon.813bdcb8c1b931aaa4fd04e304982627.svg";
export { ForwardRef as ReactComponent };